import DealerAdContainer from './DealerAdIframe.container';
import DealerAd from './DealerAdIframe';
export default DealerAdContainer(DealerAd);

//# sourceMappingURL=index.js.map